import type { TeammateAccountGrading } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { FC } from "react";
import { useBasicTeammateQuery } from "../../api/entities/teammate.js";
import { TeammateNameStack } from "./teammateNameStack.js";

interface GradingsTableTeammateCellProps {
  grading: TeammateAccountGrading;
}

export const GradingsTableTeammateCell: FC<GradingsTableTeammateCellProps> = (
  props,
) => {
  const { data: teammate, isLoading } = useBasicTeammateQuery(
    props.grading.teammate_id,
  );
  return <TeammateNameStack teammate={teammate} isLoading={isLoading} />;
};
